import type { DatePatternOption, TimePatternOption } from './types';

/**
 * Date format options (label + `date-fns`-style pattern). Ordered with the
 * European-style pattern first since the suite's primary market is IE/UK/EU.
 * Labels include a worked example so users can preview at a glance.
 */
export const DATE_PATTERNS: readonly DatePatternOption[] = [
  { pattern: 'dd/MM/yyyy', label: 'dd/MM/yyyy (31/12/2026)' },
  { pattern: 'dd-MM-yyyy', label: 'dd-MM-yyyy (31-12-2026)' },
  { pattern: 'dd.MM.yyyy', label: 'dd.MM.yyyy (31.12.2026)' },
  { pattern: 'MM/dd/yyyy', label: 'MM/dd/yyyy (12/31/2026)' },
  { pattern: 'yyyy-MM-dd', label: 'yyyy-MM-dd (2026-12-31)' },
  { pattern: 'd MMM yyyy', label: 'd MMM yyyy (31 Dec 2026)' },
  { pattern: 'MMMM d, yyyy', label: 'MMMM d, yyyy (December 31, 2026)' },
];

/** Time format options. Two for now — 24h is the default for IE/UK/EU. */
export const TIME_PATTERNS: readonly TimePatternOption[] = [
  { pattern: 'HH:mm', label: 'HH:mm (23:59)' },
  { pattern: 'hh:mm a', label: 'hh:mm a (11:59 PM)' },
];
